import { render } from "./GlobalWidget.vue?vue&type=template&id=61a2a835"
import script from "./GlobalWidget.vue?vue&type=script&lang=js"
export * from "./GlobalWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__